/*
 * @Description: 使用示例
this.HTTP.getBar().then((res) => {
    console.log(res)
}).catch(err=>{
    console.log(err);
});
 * @version: 
 * @Company: ule.com
 * @Author: ailin
 * @LastEditors: ailin
 * @Date: 2019-04-30 17:05:58
 * @LastEditTime: 2019-05-15 10:58:14
 */
/*
 * @Description: 所有http请求公用方法
 * @version: 
 * @Company: ule.com
 * @Author: ailin
 * @LastEditors: ailin
 * @Date: 2019-04-28 14:27:20
 * @LastEditTime: 2019-05-07 11:33:30
 */
import resource from '../../resource/';
import * as URL from './url.js'
export default {
    install(Vue, options) {
        Vue.prototype.HTTP = {
            // 获取系统时间
            datetime() {
                return new Promise((resolve, reject) => {
                    const params = {
                        type: '2'
                    }
                    Vue.http.jsonp(
                            URL.datetime, {
                                params: params,
                                method: 'get',
                                dataType: "jsonp",
                                jsonp: "callback"
                            }
                        )
                        .then(function(res) {
                            resolve(res.data);
                        }).catch(err => {
                            console.log("获取系统时间接口出错：" + err);
                            reject(err);
                        })
                })
            },
            // 活动场次查询
            getActivityInfos(themeCode, jsoncallback) {
                return new Promise((resolve, reject) => {
                    const params = {}
                    let url = URL.getActivityInfos + themeCode;
                    let callback = jsoncallback ? jsoncallback : 'jsoncallback12'
                    Vue.http.jsonp(
                            url, {
                                params: params,
                                method: 'get',
                                dataType: "jsonp",
                                jsonp: "jsoncallback",
                                jsonpCallback: callback
                            }
                        )
                        .then(function(res) {
                            resolve(res.data);
                        }).catch(err => {
                            console.log("活动场次查询接口出错：" + err);
                            reject(err);
                        })
                })
            },
            //签到次数查询接口
            querySingCount(signConfigNo, userOnlyId) {
                return new Promise((resolve, reject) => {
                    const params = {
                        signConfigNo: signConfigNo, //签到号
                        ruleCount: 5,
                        channel: 200000,
                        userOnlyId: userOnlyId
                    }
                    Vue.http.jsonp(
                            URL.querySingCount, {
                                params: params,
                                method: 'get',
                                dataType: "jsonp",
                                jsonp: "callback"
                            }
                        )
                        .then(function(res) {
                            resolve(res.data);
                        }).catch(err => {
                            console.log("签到次数查询接口出错：" + err);
                            reject(err);
                        })
                })
            },
            //获取用户信息cookie接口
            getIndexCookies() {
                return new Promise((resolve, reject) => {
                    const params = {}
                    Vue.http.jsonp(
                            URL.getIndexCookies, {
                                params: params,
                                method: 'get',
                                dataType: "jsonp",
                                jsonp: "jsonCallBack"
                            }
                        )
                        .then(function(res) {
                            resolve(res.data);
                        }).catch(err => {
                            console.log("获取用户信息接口出错：" + err);
                            reject(err);
                        })
                })
            },
            //抽奖资格查询
            getActivityTimes(activityCode, fieldId, userOnlyId) {
                return new Promise((resolve, reject) => {
                    const params = {
                        activityCode: activityCode, //活动code
                        fieldId: fieldId,
                        userOnlyId: userOnlyId
                    }
                    Vue.http.jsonp(
                            URL.getActivityTimes, {
                                params: params,
                                method: 'get',
                                dataType: "jsonp",
                                jsonp: "jsoncallback"
                            }
                        )
                        .then(function(res) {
                            resolve(res.data);
                        }).catch(err => {
                            console.log("抽奖接口出错：" + err);
                            reject(err);
                        })
                })
            },
            //多个抽奖资格查询
            getBatchActivityTimes(activityCode, userOnlyId) {
                console.log(activityCode)
                return new Promise((resolve, reject) => {
                    const params = {
                        activityCode: activityCode, //活动code，多个使用","隔开
                        userOnlyId: userOnlyId
                    }
                    Vue.http.jsonp(
                            URL.getBatchActivityTimes, {
                                params: params,
                                method: 'get',
                                dataType: "jsonp",
                                jsonp: "jsoncallback"
                            }
                        )
                        .then(function(res) {
                            resolve(res.data);
                        }).catch(err => {
                            console.log("多个抽奖资格查询接口出错：" + err);
                            reject(err);
                        })
                })
            },
            //抽奖接口
            lottry(activityCode, fieldId, userOnlyId) {
                return new Promise((resolve, reject) => {
                    const params = {
                        activityCode: activityCode, //活动code
                        fieldId: fieldId, //场次id
                        userOnlyId: userOnlyId,
                        channel: 200000, //渠道code
                        deviceId: "", //设备号
                    }
                    Vue.http.jsonp(
                            URL.lottry, {
                                params: params,
                                method: 'get',
                                dataType: "jsonp",
                                jsonp: "jsoncallback"
                            }
                        )
                        .then(function(res) {
                            resolve(res.data);
                        }).catch(err => {
                            console.log("抽奖接口出错：" + err);
                            reject(err);
                        })
                })
            },
            
            //签到接口
            signup(signConfigNo) {
                return new Promise((resolve, reject) => {
                    const params = {
                        signConfigNo: signConfigNo, //签到号
                        signDate: "", //为空默认为当天时间 yyyy-MM-dd （必须按这个格式）
                        businessCode: "RETAIL",
                        channel: 200000
                    }
                    Vue.http.jsonp(
                            URL.signup, {
                                params: params,
                                method: 'get',
                                dataType: "jsonp",
                                jsonp: "jsoncallback",
                            }
                        )
                        .then(function(res) {
                            resolve(res.data);
                        }).catch(err => {
                            console.log("签到接口出错：" + err);
                            reject(err);
                        })
                })
            },
            countUsernum(cardActivityNo) { //查询集卡活动参与人数
                return new Promise((resolve, reject) => {
                    var params={
                        cardActivityNo: cardActivityNo,
                    };
                    Vue.http.jsonp(URL.countUser, { params: params, jsonp: "jsonCallBack", jsonApiCallback: 'json1' }).then(function(res) {
                        resolve(res);
                    }).catch(err => {
                        reject(err);
                    })
                })

            },
            dwRecommond(event,num) { //商品广告推荐位
                return new Promise((resolve, reject) => {
                    Vue.http.jsonp(URL.dwrecommond+'jsonp31/'+num+'/null/null/'+event.join("-")+'.html', {jsonp: "jsonpCallback", jsonpCallback: 'jsonp31' }).then(function(res) {
                        resolve(res);
                    }).catch(err => {
                        reject(err);
                    })
                })

            },
            qryinfobyOwner(event,num) { //用户当天分享成单次数查询
                return new Promise((resolve, reject) => {
                    Vue.http.jsonp(URL.qryinfobyOwner, {jsonp: "jsoncallback"}).then(function(res) {
                        resolve(res);
                    }).catch(err => {
                        reject(err);
                    })
                })

            },
            takeBoxs(activityCode) { //抽奖资格查询
                return new Promise((resolve, reject) => {
                    var params={
                        activityCode:activityCode,
                        fieldId: ""
                    };
                    Vue.http.jsonp(URL.getActivityTimes, {params:params,jsonp: "jsoncallback"}).then(function(res) {
                        resolve(res);
                    }).catch(err => {
                        reject(err);
                    })
                })

            },
            cardsnumhttp(cardActivityNo) { //查询用户卡片数量是否合成
                return new Promise((resolve, reject) => {
                    var params={
                        cardActivityNo:cardActivityNo,
                    };
                    Vue.http.jsonp(URL.myCardInfos, {params:params,jsonp: "jsonCallBack"}).then(function(res) {
                        resolve(res);
                    }).catch(err => {
                        reject(err);
                    })
                })

            },
            userCardhttp(cardActivityNo) { //查询用户大卡
                return new Promise((resolve, reject) => {
                    var params={
                        activityNo:cardActivityNo,
                    };
                    Vue.http.jsonp(URL.queryUserCard, {params:params,jsonp: "jsonCallBack"}).then(function(res) {
                        resolve(res);
                    }).catch(err => {
                        reject(err);
                    })
                })

            },
            lottryhttp(activityCode) { //抽卡
                return new Promise((resolve, reject) => {
                    var channel;
                    if($.browser.ylxd){
                        channel='600000'
                    }else {
                        channel='200000'
                    }
                    var data= {
                        activityCode:activityCode, //活动code
                        fieldId: '', //场次id
                        channel: channel, //渠道code
                        deviceId: "", //设备号
                    };
                    Vue.http.jsonp(URL.lottry, {params:data,jsonp: "jsoncallback"}).then(function(res) {
                        resolve(res);
                    }).catch(err => {
                        reject(err);
                    })
                })

            },
            combinehttp(cardActivityNo,ruleCode) { //合成卡片
                return new Promise((resolve, reject) => {
                    var channel;
                    if($.browser.ylxd){
                        channel='600000'
                    }else {
                        channel='200000'
                    }
                    var params={
                        cardActivityNo:cardActivityNo,
                        ruleCode:ruleCode,
                        channel:channel
                    };
                    Vue.http.post(URL.combine, params,{emulateJSON: true, credentials:true}).then(function(res) {
                        resolve(res);
                    }).catch(err => {
                        reject(err);
                    })
                })
            },
            turnOverTheCardhttp(cardActivityNo,activityCode,channelka) { //抽奖翻卡
                return new Promise((resolve, reject) => {
                    var channel;
                    if($.browser.ylxd){
                        channel='600000'
                    }else {
                        channel='200000'
                    }
                    channelka=channelka||channel;
                    var params={
                        cardActivityNo: cardActivityNo,
                        cardNo:activityCode,
                        channel:channelka
                    };
                    Vue.http.post(URL.turnOverTheCard, params,{emulateJSON: true, credentials:true}).then(function(res) {
                        resolve(res);
                    }).catch(err => {
                        reject(err);
                    })
                })

            },
            cationByRulehttp(ruleCode,tim) { //邮乐查询用户当天完成次数
                return new Promise((resolve, reject) => {
                    var params={
                        ruleCode:ruleCode,
                        startTime:tim,
                        endTime:tim,

                    };
                    Vue.http.jsonp(URL.queryQualificationByRule, {params:params,jsonp: "jsoncallback"}).then(function(res) {
                        resolve(res);
                    }).catch(err => {
                        reject(err);
                    })
                })

            },
            queryYxdTeamhttp(){//查询用户是否加入战队
                return new Promise((resolve, reject) => {
                    Vue.http.jsonp(URL.queryYxdTeamByOwnerIdForUle, {jsonp: "jsoncallback"}).then(function(res) {
                        resolve(res);
                    }).catch(err => {
                        reject(err);
                    })
                })
            },
            qryGiverInfohttp(){//查询战队成员
                return new Promise((resolve, reject) => {
                    var params={
                        pageIndex:1,
                        pageSize:1000,
                    };
                    Vue.http.jsonp(URL.qryGiverInfo, {params:params,jsonp: "jsoncallback"}).then(function(res) {
                        resolve(res);
                    }).catch(err => {
                        reject(err);
                    })
                })
            },
            exChangeCardshttp(cardId,nextUserId,cardActivityNo){//增送卡片接口
                return new Promise((resolve, reject) => {
                    var params={
                        cardId:cardId,
                        nextUserId:nextUserId,
                        cardActivityNo:cardActivityNo
                    };
                    Vue.http.jsonp(URL.exChangeCards, {params:params,jsonp: "jsoncallback"}).then(function(res) {
                        resolve(res);
                    }).catch(err => {
                        reject(err);
                    })
                })
            },
            qryReAndSendCardhttp(flag,activityCode){//赠卡纪录
                return new Promise((resolve, reject) => {
                    var params={
                        flag:flag,
                        activityNo:activityCode
                    };
                    Vue.http.jsonp(URL.qryReAndSendCardsHis, {params:params,jsonp: "jsoncallback"}).then(function(res) {
                        resolve(res);
                    }).catch(err => {
                        reject(err);
                    })
                })
            }
        };

    }

}


// WEBPACK FOOTER //
// ./src/assets/js/http.js